module.exports = __webpack_public_path__ + "static/media/dna.f1a248c5.svg";